angular.module("fondiBeiPv.components", []).component("fondiBeiPv", {
  templateUrl: "ng/components/fondiBeiPv/fondiBeiPv.html",
  controllerAs: "FondiBeiPvCtrl",
  bindings: {
    exportValidityQuestionario: "&",
    model: "=",
    convenzione: "<"
  },
  controller: FondiBeiPvController,
});

function FondiBeiPvController() {
  var self = this;

  self.$onInit = function () {
    self.model.questionarioBei.rb1 = null;
    self.model.questionarioBei.rb5 = null;
    self.supportModel = {
      impresa: self.model.questionarioBei.rb1,
      impresaAutonoma: self.model.questionarioBei.rb2,
      impresaAssociata: self.model.questionarioBei.rb3,
      impresaCollegata: self.model.questionarioBei.rb4,
      settoriEsclusi: self.model.questionarioBei.rb5,
      numDipendenti: self.model.questionarioBei.numDipendenti,
      codiceAteco: self.model.destinatario.ateco,
      periodo: self.model.questionarioBei.periodo,
    };
    self.regex = null;
    self.labelWarningNumDipendentiVisible = false;
    checkValidityQuestionario();
    checkRegexConvenzione()
    self.handleChange('numDipendenti', self.model.questionarioBei.numDipendenti)
  };

  self.handleChange = function (property, value) {
    switch (property) {
      case "rb2":
        if (value) {
          self.supportModel.impresaAssociata = false;
          self.supportModel.impresaCollegata = false;
          self.model.questionarioBei.rb3 = false;
          self.model.questionarioBei.rb4 = false;
        }
        break;
      case "rb3":
        if (value) {
          self.supportModel.impresaAutonoma = false;
          self.supportModel.impresaCollegata = false;
          self.model.questionarioBei.rb2 = false;
          self.model.questionarioBei.rb4 = false;
        }
        break;
      case "rb4":
        if (value) {
          self.supportModel.impresaAutonoma = false;
          self.supportModel.impresaAssociata = false;
          self.model.questionarioBei.rb2 = false;
          self.model.questionarioBei.rb3 = false;
        }
        break;
      case "numDipendenti":
        var numDipendentiValid = self.regex.test(value);
        if (!numDipendentiValid && value){
          self.labelWarningNumDipendentiVisible = true;
        } else {
          self.labelWarningNumDipendentiVisible = false;
        }
        break;
    }
    self.model.questionarioBei[property] = value;
    checkValidityQuestionario();
  };

  var checkValidityQuestionario = function () {
    if (
      self.model.questionarioBei.rb1 != undefined &&
      self.model.questionarioBei.rb1 != null &&
      self.model.questionarioBei.rb2 != undefined &&
      self.model.questionarioBei.rb2 != null &&
      self.model.questionarioBei.rb3 != undefined &&
      self.model.questionarioBei.rb3 != null &&
      self.model.questionarioBei.rb4 != undefined &&
      self.model.questionarioBei.rb4 != null &&
      self.model.questionarioBei.rb5 != undefined &&
      self.model.questionarioBei.rb5 != null &&
      self.model.questionarioBei.numDipendenti &&
      // self.model.destinatario.ateco &&
      self.model.questionarioBei.periodo
    ) {
      self.exportValidityQuestionario({
        validity: true,
      });
    } else {
      self.exportValidityQuestionario({
        validity: false,
      });      
    }
    if(self.supportModel.impresa == false || self.supportModel.settoriEsclusi == true || self.labelWarningNumDipendentiVisible) {
      self.model.questionarioBeiInadeguato = true;
    } else if(self.supportModel.impresa == true && self.supportModel.settoriEsclusi == false && !self.labelWarningNumDipendentiVisible) {
      self.model.questionarioBeiInadeguato = false;
    }
  };

  var checkRegexConvenzione = function () {
    switch (self.convenzione) {
      case "HO1":
      case "H95":
      case "IE4":
      case "IX1":
      case "LG4":
        self.regex = new RegExp("^(2[5-9]{1}[0-9]{1}|[3-9]{1}[0-9]{2}|[1-2]{1}[0-9]{3})$");;
        self.labelWarningNumDipendenti = 'ERROR_FIELD_NUMERICFONDIBEIHO1'
        break;
      case "HO0":
      case "H94":
      case "IE3":
      case "IX0":
      case "LG3":
        self.regex = new RegExp("^([1-9]|1[0-9]{1,2}|[2-9]{1}[0-9]{1}|2[0-4]{1,2}[0-9]{1,2})$");;
        self.labelWarningNumDipendenti = 'ERROR_FIELD_NUMERICFONDIBEIHO0'
        break;
      default:
        self.regex = new RegExp("^([1-9]{1}[0-9]*)$");
        self.labelWarningNumDipendenti = 'ERROR_FIELD_NUMERICFONDIBEIDEFAULT'
        break;
    }
  };
}
